module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00173.6c4dbc18.jpg";